export default "__VITE_ASSET__d023d065__$_?inline__"